import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import countries from '../../util/countries';
import styles from './styles.scss';

const initialState = {
  fullName: '',
  email: '',
  phoneNumber: '',
  city: '',
  timeZone: '',
  country: '',
  websiteURL: '',
  companyName: '',
  idea: '',
  product: '',
  experience: '',
  team: '',
  beenWorking: '',
  whatWork: '',
  problem: '',
  problemFor: '',
  competition: '',
  makeMoney: '',
  heardAboutUs: '',
  sending: false
};

class StartupApply extends Component {
  state = {
    ...initialState
  };

  render() {
    const {
      fullName,
      email,
      phoneNumber,
      city,
      timeZone,
      country,
      websiteURL,
      companyName,
      idea,
      product,
      experience,
      team,
      beenWorking,
      whatWork,
      problem,
      problemFor,
      competition,
      makeMoney,
      heardAboutUs,
      sending
    } = this.state;

    return (
      <DocumentTitle title='0-to-startup - Apply'>
        <div>
          <form onSubmit={this.onSubmitForm} className={`${styles.contactForm} ${styles.application}`}>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-9 col-center mt50">
                    <div className="text-center">
                      <h1 className="mb40">
                        Founder Application
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="form-group">
                      <label className="bold" htmlFor="fullName">YOUR NAME</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="fullName"
                        placeholder="Enter full name"
                        name="fullName"
                        value={fullName}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="email">EMAIL</label>
                      <input
                        type="email"
                        className="form-control input-lg"
                        id="email"
                        placeholder="Enter your Email"
                        name="email"
                        value={email}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="phoneNumber">PHONE NUMBER</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="phoneNumber"
                        placeholder="e.g. (404) 444-4444"
                        name="phonenumber"
                        value={phoneNumber}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="country">YOUR COUNTRY OF RESIDENCE</label>
                      <Select
                        name="country"
                        placeholder="Select Country"
                        clearable={false}
                        searchable={false}
                        value={country}
                        options={countries.map(country => { return {value: country, label: country} })}
                        onChange={this.onSelectCountry}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="city">CITY</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="city"
                        placeholder="Enter your City"
                        name="city"
                        value={city}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="timeZone">TIME ZONE</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="timeZone"
                        placeholder="Enter your Time Zone"
                        name="timeZone"
                        value={timeZone}
                        onChange={this.onChangeField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="form-group">
                      <label className="bold" htmlFor="companyName">YOUR COMPANY NAME</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="companyName"
                        placeholder="Enter your company name"
                        name="companyName"
                        value={companyName}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="websiteURL">YOUR COMPANY URL, IF ANY</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="websiteURL"
                        placeholder="www.YOURWEBSITE.com"
                        name="websiteURL"
                        value={websiteURL}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="idea">DESCRIBE YOUR STARTUP IDEA IN ONE SENTENCE</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="idea"
                        placeholder="My startup idea is to..."
                        name="idea"
                        value={idea}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="product">WHAT WILL BE YOUR FIRST PRODUCT?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="product"
                        placeholder="Our first product will be..."
                        name="product"
                        value={product}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="experience">WHAT IS YOUR PAST STARTUP OR WORK EXPERIENCE?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="experience"
                        placeholder="In the past..."
                        name="experience"
                        value={experience}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="team">HOW MANY FOUNDERS ARE THERE? WHO'S ON YOUR TEAM?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="team"
                        placeholder="We have..."
                        name="team"
                        value={team}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="beenWorking">HOW LONG HAVE YOU BEEN WORKING ON YOUR IDEA?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="beenWorking"
                        placeholder="We've been working..."
                        name="beenWorking"
                        value={beenWorking}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="whatWork">IN WHAT WAY HAVE YOU WORKED ON YOUR IDEA?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="whatWork"
                        placeholder="We've worked..."
                        name="whatWork"
                        value={whatWork}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="problem">WHAT PROBLEM ARE YOU TRYING TO SOLVE</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="problem"
                        placeholder="The problem we're..."
                        name="problem"
                        value={problem}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="problemFor">WHO ARE YOU TRYING TO SOLVE THIS PROBLEM FOR?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="problemFor"
                        placeholder="We're trying to..."
                        name="problemFor"
                        value={problemFor}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="competition">WHO ARE YOUR COMPETITORS?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="competition"
                        placeholder="Our competitors..."
                        name="competition"
                        value={competition}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="makeMoney">HOW WILL THIS IDEA MAKE MONEY?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="makeMoney"
                        placeholder="This will make..."
                        name="makeMoney"
                        value={makeMoney}
                        onChange={this.onChangeField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="form-group">
                      <label className="bold" htmlFor="heardAboutUs">HOW DID YOU HEAR ABOUT 0-TO-STARTUP?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="heardAboutUs"
                        placeholder="I heard..."
                        name="heardAboutUs"
                        value={heardAboutUs}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="row">
                      <div className="col-xs-12 text-right mb100">
                        <button className="btn btn-dc-blue btn-xs-block" disabled={sending} type="submit">JOIN US</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </DocumentTitle>
    );
  }

  onChangeField = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  onSelectCountry = (country) => {
    this.setState({
      country: country.value
    });
  }

  onSubmitForm = (event) => {
    event.preventDefault();
    this.setState({
      sending: true
    }, this.sendFormData);
  }

  sendFormData = () => {
    const formData = {
      "application_type": this.state.applicationType,
      "full_name": this.state.fullName,
      "email": this.state.email,
      "phone_number": this.state.phoneNumber,
      "country": this.state.country,
      "city": this.state.city,
      "time_zone": this.state.timeZone,
      "website_URL": this.state.websiteURL,
      "company_name": this.state.companyName,
      "idea": this.state.idea,
      "product": this.state.product,
      "experience": this.state.experience,
      "team": this.state.team,
      "time_been_working": this.state.beenWorking,
      "what_worked_on_so_far": this.state.whatWork,
      "problem": this.state.problem,
      "problem_solve_for": this.state.problemFor,
      "competition": this.state.competition,
      "how_make_money": this.state.makeMoney,
      "heard_about_designcue": this.state.heardAboutUs
    };

    $.ajax({
      url: 'https://formspree.io/pa@designcue.co',
      method: 'POST',
      dataType: 'json',
      data: {
        ...formData
      },
      success: function(res) {
        this.setState({ ...initialState }, this.props.submitSuccess('application'));
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(status, err.toString());
      }
    });
  }
}

export default StartupApply;



// WEBPACK FOOTER //
// ./src/pages/StartupApply/index.js